// extracted by mini-css-extract-plugin
module.exports = {"root":"ImgPreviewModal_root__3kLWl","closeBtn":"ImgPreviewModal_closeBtn__16ybE"};